import { render, staticRenderFns } from "./AddKYCFilesModal.vue?vue&type=template&id=1a5831a1&scoped=true&"
import script from "./AddKYCFilesModal.vue?vue&type=script&lang=js&"
export * from "./AddKYCFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5831a1",
  null
  
)

export default component.exports